module.exports = require('../dist/contexts/MarketplaceProductCardContext');
